/* eslint-disable import/no-anonymous-default-export */
import project from "../models/project";
import moment from 'moment';

export const types = {
  PROJECT_REQUEST: "PROJECT_REQUEST",
  CADD_REPORT_REQUEST: "CADD_REPORT_REQUEST",
  CADD_REPORT_SUCCESS: "CADD_REPORT_SUCCESS",
  CADD_REPORT_FAILED: "CADD_REPORT_FAILED",
  PROJECT_DATA: "PROJECT_DATA",
  PROJECT_SUCCESS: "PROJECT_SUCCESS",
  PROJECT_FAILED: "PROJECT_FAILED",
  PROJECT_DATA_SUCCESS: "PROJECT_DATA_SUCCESS",
  PROJECT_DATA_FAILED: "PROJECT_DATA_FAILED",
  PROJECT_KYC: "PROJECT_KYC",
  PROJECT_KYC_SUCCESS: "PROJECT_KYC_SUCCESS",
  PROJECT_KYC_FAILED: "PROJECT_KYC_FAILED",
  PROJECT_SUBMIT_REQUEST: "PROJECT_SUBMIT_REQUEST",
  PROJECT_SUBMIT_SUCCESS: "PROJECT_SUBMIT_SUCCESS",
  PROJECT_SUBMIT_FAILED: "PROJECT_SUBMIT_FAILED",
  PROJECT_RESET: "PROJECT_RESET",
  PUBLICATIONS_UPDATE: "PUBLICATIONS_UPDATE",
  PUBLICATIONS_UPDATE_SUCCESS: "PUBLICATIONS_UPDATE_SUCCESS",
  PUBLICATIONS_UPDATE_FAILED: "PUBLICATIONS_UPDATE_FAILED",
  INVITATIONS: "INVITATIONS",
  INVITATIONS_SUCCEDDED: "INVITATIONS_SUCCEDDED",
  INVITATIONS_FAILED: "INVITATIONS_FAILED",
  PROJECT_STATUS: "PROJECT_STATUS",
  PROJECT_STATUS_SUCCEDDED: "PROJECT_STATUS_SUCCEDDED",
  PROJECT_STATUS_FAILED: "PROJECT_STATUS_FAILED",
  PROJECT_REMOVE: "PROJECT_REMOVE",
  PROJECT_REMOVE_SUCCESS: "PROJECT_REMOVE_SUCCESS",
  PROJECT_REMOVE_FAILED: "PROJECT_REMOVE_FAILED",
  UPDATE_PROJECTS: 'UPDATE_PROJECTS',
  CHANGE_SOURCES: 'CHANGE_SOURCES',
};

export const actions = {
  ProjectsGet: (payload) => {
    return { type: types.PROJECT_REQUEST, value: payload };
  },
  ChangeSources: (payload) => {
    return { type: types.CHANGE_SOURCES, value: payload };
  },
  UpdateProjects: (payload) => {
    return { type: types.UPDATE_PROJECTS, value: payload };
  },
  CaddReportsGet: (payload, callback, signal) => {
    return { type: types.CADD_REPORT_REQUEST, value: payload, callback, signal };
  },
  ProjectDataGet: (payload) => {
    return { type: types.PROJECT_DATA, value: payload };
  },
  ProjectKYCGet: (id, userId, payload) => {
    return { type: types.PROJECT_KYC, id, userId, value: payload };
  },
  ProjectSubmit: (payload, callback = () => { }) => {
    return { type: types.PROJECT_SUBMIT_REQUEST, value: payload, callback };
  },
  ResetProjectForm: (payload) => {
    return { type: types.PROJECT_RESET, value: payload };
  },
  UpdatePublications: (payload, callback = () => { }, onError) => {
    return { type: types.PUBLICATIONS_UPDATE, value: payload, callback, onError };
  },
  GetInvitedProjects: () => {
    return { type: types.INVITATIONS };
  },
  ChangeProjectStatus: (payload, callback = () => { }) => {
    return { type: types.PROJECT_STATUS, value: payload, callback };
  },
  ProjectRemove: (payload, callback = () => { }) => {
    return { type: types.PROJECT_REMOVE, value: payload, callback };
  },
};

function setViewConfig(value) {
  const { data } = value;
  if (!data) {
    return {};
  }
  return {
    title: {
      en: data.name,
      fr: data.name
    },
    tags: [
      // {
      //   label: {
      //     en: 'Country',
      //     fr: 'Country',
      //   },
      //   value: data.country,
      //   color: 'green',
      // },
      {
        label: {
          en: 'Last Edit',
          fr: 'Dernière Modification',
        },
        value: moment(data.updatedAt || data.createdAt).fromNow(),
        color: 'default',
      },
    ],
  }
}


export default (state = project, action) => {
  switch (action.type) {
    case types.CHANGE_SOURCES:
      return {
        ...state,
        sources: action.value,
      };
    case types.UPDATE_PROJECTS:
      return {
        ...state,
        data: {
          ...state.data,
          projects: action.value,
        }
      }
    case types.PROJECT_SUCCESS:
      const { data: pData = {} } = state;
      let viewConfig = state.viewConfig || {};
      if (action.key) {
        viewConfig = setViewConfig(action.value[action.key])
      }
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...pData,
          ...action.value,
        },
        viewConfig: {
          ...viewConfig,
        },
      }
    case types.PROJECT_KYC: {
      return {
        ...state,
        retrived: false,
      }
    }
    case types.PROJECT_KYC_SUCCESS:
      const { kyc: kycData = {} } = state;
      return {
        ...state,
        loading: false,
        retrived: true,
        kyc: Object.assign(kycData, action.value)
      }
    case types.PROJECT_SUBMIT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.PUBLICATIONS_UPDATE_SUCCESS:
      return {
        ...state,
      };
    case types.PROJECT_SUBMIT_SUCCESS:
      const { view, ...data } = action.value;
      if (!state.data[view]) {
        state.data[view] = {
          data: {},
          form: {},
        }
      }
      state.data[view].data = data;
      state.data.projects = (state.data.projects || []).map(d => {
        if (d.id === data.id) {
          d.name = data.name;
        }
        return d;
      });
      if (!state.data.projects) {
        state.data.projects = [];
      }
      let existProject = false;
      state.data.projects = state.data.projects.map(pr => {
        if (pr.id === data.id) {
          existProject = true;
          return data;
        }
        return pr;
      })
      if (!existProject) {
        state.data.projects.push(data);
      }
      return {
        ...state,
        loading: false,
        viewConfig: {
          ...setViewConfig(state.data[view]),
        },
      };
    case types.PROJECT_RESET:
      const viewR = action.value && action.value.view ? action.value.view : undefined;
      if (viewR) {
        if (state.data[viewR]) {
          state.data[viewR].data = {};
        }
        return state
      } else {
        return project;
      }
    case types.PROJECT_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    case types.INVITATIONS_SUCCEDDED:
      return {
        ...state,
        invitations: [
          ...action.value
        ],
      };
    case types.INVITATIONS_FAILED:
      return {
        ...state,
        invitations: [],
      };
    case types.PROJECT_STATUS_SUCCEDDED:
      state.data.projects = action.value.data;
      return {
        ...state,
      };

    case types.CADD_REPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        retrived: true,
        reports: [
          ...action.value
        ],
      }
    }
    default:
      return state;
  }
};
